import { BriefChildren } from "services/projects/project.types";
import { TBriefData } from "store/slice/Project/projectData/ProjectSlice.types";
import { mergeFacetWithMetaUi } from "utils";

export const convertBriefData = (brief: BriefChildren | undefined): TBriefData | undefined => {
    if (!brief) return;

    return {
        position: brief.data.crm_vacancy,
        roleFunction: brief.data.role_function,
        roleFunctions: [brief.data.role_function],
        roleLevel: brief.data.role_level,
        roleLevels: [brief.data.role_level],
        chart1: brief.data.functional_balance,
        chart2: brief.data.individual_positioning,
        facets: {
            situational: mergeFacetWithMetaUi(
                brief.data.facet_situational.narratives,
                brief.meta_ui?.facet_situational.narratives || [],
                true
            ),
            domain: mergeFacetWithMetaUi(
                brief.data.facet_domain.narratives,
                brief.meta_ui?.facet_domain.narratives || []
            ),
            functional: mergeFacetWithMetaUi(
                brief.data.facet_functional.narratives,
                brief.meta_ui?.facet_functional.narratives || []
            ),
        },
    };
};
